import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx", "variant", "children", "startIcon"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiTypography from '@mui/material/Typography';
import { extendSX } from '../helpers';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Typography](https://ui-packages.isbuildingluma.com/ui-core/react-typography/)
 *
 * API:
 *
 * - [Typography API](https://ui-packages.isbuildingluma.com/ui-core/api/typography/)
 * - inherits [MuiTypography API](https://mui.com/material-ui/api/typography/)
 */
const Typography = /*#__PURE__*/React.forwardRef(function Typography(_ref, ref) {
  let {
      sx,
      variant,
      children,
      startIcon
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiTypography, _extends({
    ref: ref,
    sx: extendSX(sx, theme => _extends({}, startIcon && {
      display: 'flex',
      alignItems: 'center'
    }, typeof sx === 'function' ? sx(theme) : sx))
    // Casting because we want to avoid using `TypographyPropsVariantOverrides`
    // https://mui.com/material-ui/customization/typography/#adding-amp-disabling-variants
    ,
    variant: variant
  }, rest, {
    children: rest.dangerouslySetInnerHTML ? undefined : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [startIcon, children]
    })
  }));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "TypographyProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  dangerouslySetInnerHTML: PropTypes.shape({
    __html: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
  }),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'mention', 'overline', 'squiggly', 'squigglyInvalid', 'subtitle1', 'subtitle2', 'subtitle3'])
} : void 0;
export default Typography;